'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Footer: {
        displayName: 'Footer'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Footer/Footer.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var POSITION_ABOUT = 2;
var POSITION_HELP = 3;
var POSITION_INFORMATION = 4;

var Footer = _wrapComponent('Footer')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        basementText: state.setting.basementText,
        phone: state.setting.phone,
        pageList: state.page.list,
        lang: state.lang
    };
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(Footer, _Component);

    function Footer() {
        (0, _classCallCheck3.default)(this, Footer);
        return (0, _possibleConstructorReturn3.default)(this, (Footer.__proto__ || (0, _getPrototypeOf2.default)(Footer)).apply(this, arguments));
    }

    (0, _createClass3.default)(Footer, [{
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('Footer');
            var about = [],
                help = [],
                information = [];
            var _props = this.props,
                basementText = _props.basementText,
                phone = _props.phone,
                lang = _props.lang;


            this.props.pageList.forEach(function (page) {
                switch (page.in_basement) {
                    case POSITION_ABOUT:
                        about.push({
                            title: page.title,
                            url: page.url_pages
                        });
                        break;
                    case POSITION_HELP:
                        help.push({
                            title: page.title,
                            url: page.url_pages
                        });
                        break;
                    case POSITION_INFORMATION:
                        information.push({
                            title: page.title,
                            url: page.url_pages
                        });
                        break;
                }
            });

            return _react3.default.createElement(View, {
                about: about,
                help: help,
                information: information,
                basementText: basementText,
                phone: phone,
                lang: lang
            });
        }
    }]);
    return Footer;
}(_react2.Component), _class2.propsType = {
    pageList: _react2.PropTypes.array,
    lang: _react2.PropTypes.object
}, _temp)) || _class));

exports.default = Footer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.jsx
// module id = 1659
// module chunks = 0